import { useState, useEffect } from 'react';
import { useToast } from '@veneer/core';
import * as T from '../types';
import logger from '../../../interfaces/logger';

function useAssetImport({
  assetReference,
  component,
  assetImportCallback,
  ...props
}: T.LazyMfeLoaderPropsType) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [mfe, setMfe] = useState<any>();
  const [isLoading, setIsLoading] = useState(true);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { singleSpa, mountParcel, ...rest } = props;
  const componentProps = {
    ...rest,
    useToast
  };

  useEffect(() => {
    if (assetReference || assetImportCallback) {
      setIsLoading(true);
      const importFunction = async () => {
        if (assetReference) {
          logger?.debug('Calling System.import for asset: ', assetReference);
          return System.import(assetReference);
        } else if (assetImportCallback) {
          return assetImportCallback?.();
        }
      };

      importFunction()
        .then((response) => {
          logger?.debug('System.Import successfully.');
          setMfe(response);
        })
        .catch((error) => {
          logger?.warn(
            'System.Import failed for AssetReference:',
            assetReference
          );
          logger?.error('System.Import failed, error message:', error);
          setMfe(undefined);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      setMfe(undefined);
      setIsLoading(false);
    }
  }, [assetReference, assetImportCallback]);

  useEffect(() => {
    if (!mfe?.default && !isLoading && component) {
      setMfe({ default: component });
    }
  }, [component, isLoading, mfe]);

  return {
    mfe,
    isLoading,
    componentProps
  };
}

export default useAssetImport;
